import { isEmpty, get, isArray, flatten } from 'lodash';
import {
  CLAIM_TYPE,
  DOCUMENT_NAME,
} from 'containers/IdentificationPage/SearchResults/ClaimWithNotIndexedPV/constants';
import {
  BawabaAndSagisClaims,
  BawabaClaim,
  IndexedDocument,
  Policy,
  SagisClaim,
  SearchClaims,
} from 'containers/IdentificationPage/typings';
import { Config } from 'containers/AppContainer/typings';
import { Document } from 'containers/ManagerDocumentsPage/typings';
import { DOCUMENT_TYPES } from 'constants/global';

export const addBawabaIndexedDocumentsToSagisClaims = (
  searchResult: SearchClaims,
) => {
  const { corporeal, sagis, existingClaims } = searchResult;

  return sagis?.claims.map((c: SagisClaim) => {
    const existingClaimsdocuments = existingClaims
      .filter(e => e.claimNumber === c.code)
      .map(ec => ec.documents);

    const preopenedClaimDocuments = corporeal
      .filter(corpo => corpo.claimNumber === c.code)
      .map(ec => ec.documents);

    return {
      ...c,
      documents: flatten([
        ...existingClaimsdocuments,
        ...preopenedClaimDocuments,
      ]),
    };
  });
};

export const concatClaims = (
  corporeal: BawabaClaim[],
  sagisClaim: SagisClaim[],
) => {
  if (isEmpty(corporeal)) return sagisClaim;
  if (isEmpty(sagisClaim)) return corporeal;

  const filteredCorporelClaims = corporeal.filter((sc: BawabaClaim) =>
    sagisClaim?.some((c: SagisClaim) => c.code !== sc.claimNumber),
  );

  return [...sagisClaim, ...filteredCorporelClaims];
};

export const addSagisIndexedDocumentsToClaims = (
  claims: BawabaAndSagisClaims[],
) => {
  return claims.map((c, index: number) => {
    let _claim = { ...c };

    if (isArray(c.documentsIndexed)) {
      _claim.documents = [
        ...c.documentsIndexed?.map((doc, i: number) => ({
          name: `${DOCUMENT_NAME}-${i + 1}`,
          type: doc,
        })),
        ...get(c, 'documents', []),
      ];
    }

    const bawabandexedDocuments = c.documents.filter(
      doc => doc.type === DOCUMENT_TYPES.PV,
    );

    if (c.doesPVExists && isEmpty(bawabandexedDocuments)) {
      _claim.documents.push({
        name: `${DOCUMENT_NAME}`,
        type: DOCUMENT_TYPES.PV,
      });
    }

    return _claim;
  });
};

export const formatterHelper = {
  addBawabaIndexedDocumentsToSagisClaims,
  concatClaims,
  addSagisIndexedDocumentsToClaims,
};

export const dataFormater = (searchResult: SearchClaims) => {
  //Add existing claims documents to sagis.claim
  const sagisClaimsBawabaDocuments = formatterHelper.addBawabaIndexedDocumentsToSagisClaims(
    searchResult,
  );

  //Concat sagis.claims and corporel and return none duplicated claims
  const concatAllClaims = sagisClaimsBawabaDocuments;
  return formatterHelper.addSagisIndexedDocumentsToClaims(
    concatAllClaims as BawabaAndSagisClaims[],
  );
};

export const canUpload = (
  documents: Document[],
  requiredDocuments: Config[],
) => {
  if (!isArray(documents) || isEmpty(requiredDocuments)) return false;

  const requiredDecumentsToUpload = requiredDocuments.map(ele => ele.name);

  return !documents.some(doc => requiredDecumentsToUpload.includes(doc.type));
};

export const getRequiredDocumentsToIndex = (
  requiredDocuments: Config[],
  documents: IndexedDocument[],
) => {
  if (!isArray(documents)) {
    return [];
  }

  return requiredDocuments.filter(
    rd => !documents.some(doc => doc.type === rd.name),
  );
};

export const existingClaimFormater = (claim: SagisClaim, policy: Policy) => {
  return {
    policyNumber: get(claim, 'policyNumber'),
    claimNumber: get(claim, 'code', null),
    lossHour: get(claim, 'lossTime') || get(claim, 'lossHour'),
    lossDate: get(claim, 'lossDate'),
    totalVictims: 0,
    status: get(claim, 'status'),
    vehiculeBrand: get(policy, 'vehicleMark'),
    claimNature: get(claim, 'claimType', CLAIM_TYPE.CORPOREL),
    registrationNumber: get(claim, 'registrationNumber'),
    lossLocation: get(claim, 'lossLocation'),
  };
};

/* istanbul ignore next */
export const emptyFile = () => {
  let list = new DataTransfer();
  let resetFile = new File([''], '');
  list.items.add(resetFile);

  return list;
};
